import * as courseTemplatesTypes from "Store/courseTemplates/constants";

export const setCourseTemplate = (payload: CourseTemplate[]) => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATE,
  payload
});

export const setCourseTemplatesByTypes = (templates, templateType) => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATES_BY_TYPE,
  payload: {
    templates,
    templateType
  }
});

export const setCourseTemplateSessions = (sessionSchedule) => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATE_SESSIONS,
  payload: sessionSchedule
});

export const getCourseTemplateSessions = (postBody) => ({
  type: courseTemplatesTypes.GET_COURSE_TEMPLATE_SESSIONS,
  postBody
});

export const fetchMoreCourses = (templateType) => ({
  type: courseTemplatesTypes.FETCH_MORE_COURSE_TEMPLATES,
  templateType
});

export const setCourseTemplateQuery = (queryType, queryName, query) => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATE_QUERY,
  queryType,
  queryName,
  query
});

export const queryCourseTemplate = (queryName, query) => ({
  type: courseTemplatesTypes.QUERY_COURSE_TEMPLATE,
  queryName,
  query
});

export const createCourseTemplate = (newTemplate, templateType) => ({
  type: courseTemplatesTypes.HANDLE_CREATE_COURSE_TEMPLATE,
  newTemplate,
  templateType
});

export const clearCourseTemplateFilters = (shouldRefetchCourseTemplates = true) => ({
  type: courseTemplatesTypes.CLEAR_COURSE_TEMPLATE_FILTERS,
  shouldRefetchCourseTemplates
});

export const setCourseTemplatesFiltersClear = (queryOptionsClear) => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATES_FILTERS_CLEAR,
  payload: queryOptionsClear
});

/* REFACTORED */
export const handleFetchCourseTemplates =
  (): courseTemplatesTypes.IHandleFetchAllCourseTemples => ({
    type: courseTemplatesTypes.HANDLE_FETCH_ALL_COURSE_TEMPLATES
  });

export const setCourseTemplateLoader = (
  payload: boolean
): courseTemplatesTypes.ISetCourseTemplateLoader => ({
  type: courseTemplatesTypes.SET_COURSE_TEMPLATE_LOADER,
  payload
});

export const handleApplyTemplateToStudent = (
  payload: ApplyTemplateRequest
): courseTemplatesTypes.IHandleApplyTemplateToStudent => ({
  type: courseTemplatesTypes.HANDLE_APPLY_TEMPLATE_TO_STUDENT,
  payload
});

export const handleApplyTemplateToClass = (
  payload: ApplyTemplateRequest
): courseTemplatesTypes.IHandleApplyTemplateToClass => ({
  type: courseTemplatesTypes.HANDLE_APPLY_TEMPLATE_TO_CLASS,
  payload
});

export const handleFetchSelectedCourseTemplate = (
  payload: string
): courseTemplatesTypes.IHandleFetchSelectedCourseTemplate => ({
  type: courseTemplatesTypes.HANDLE_FETCH_SELECTED_COURSE_TEMPLATE,
  payload
});

export const setSelectedCourseTemplate = (
  payload: CourseTemplate
): courseTemplatesTypes.ISetSelectedCourseTemplate => ({
  type: courseTemplatesTypes.SET_SELECTED_COURSE_TEMPLATE,
  payload
});

export const handleDeleteCourseTemplates = (
  courseTemplatesIds: string[]
): courseTemplatesTypes.IHandleDeleteCourseTemplates => ({
  type: courseTemplatesTypes.HANDLE_DELETE_COURSE_TEMPLATES,
  payload: {
    courseTemplatesIds
  }
});

export const handleCreateCourseTemplate = (
  courseTemplate: CourseTemplate,
  fromCalendar?: boolean,
  classroomTemplate?: boolean
): courseTemplatesTypes.IHandleCreateCourseTemplate => ({
  type: courseTemplatesTypes.HANDLE_CREATE_COURSE_TEMPLATE,
  payload: {
    courseTemplate,
    fromCalendar,
    classroomTemplate
  }
});

export const handleUpdateCourseTemplate = (
  courseTemplate: CourseTemplate
): courseTemplatesTypes.IHandleUpdateCourseTemplate => ({
  type: courseTemplatesTypes.HANDLE_UPDATE_COURSE_TEMPLATE,
  payload: {
    courseTemplate
  }
});
